<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <div class="layout-container max-w-full">
        <div class="max-md:hidden">
<!--            <TopBar/>-->
        </div>
        <main>
            <slot/>
        </main>
        <FooterSection/>
    </div>
</template>

<script>
import FooterSection from "@js/components/FooterSection.vue";

export default {
    name: "Layout",
    components: {
        FooterSection

    },
    props: {
        title: String,
        description: String,
    },
    mounted() {

    },
    setup(props) {

    }
}
</script>

<style lang="scss" scoped>
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    main {
        flex: 1;
    }
}
</style>
